import { deleteProfileImage, getUserProfile, patchUser, updateProfileImage } from '@pequity/shared/api/auth';
import type { UserPatchPayload, UserProfile } from '@pequity/shared/types/user';
import { defineStore } from 'pinia';

const LOCALE_STORAGE_KEY = 'user_locale';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loggedIn: false,
    profile: {} as UserProfile,
  }),
  getters: {
    userId: (state) => state.profile.id,
    isUserAdmin: (state) => !!state.profile.is_admin,
    isUserTeamlead: (state) => !!state.profile.is_teamlead,
    hasPeopleAccess: (state) => !!state.profile.has_people_access,
    appAccess: (state) => state.profile.app_access,
    isUserStaff: (state) => !!state.profile.is_staff,
    isStaffMode: (state) => state.loggedIn && !!state.profile.staff_mode,
  },
  actions: {
    async setUserProfileAndLoggedInState() {
      const { data, error } = await getUserProfile();

      if (!error) {
        this.profile = data;
        this.loggedIn = true;
      }
    },
    async updateProfileImage(image: File) {
      const { error } = await updateProfileImage(this.profile.id, image);
      if (!error) {
        await this.setUserProfileAndLoggedInState();
      }
    },
    async deleteProfileImage() {
      const { error } = await deleteProfileImage(this.profile.id);
      if (!error) {
        await this.setUserProfileAndLoggedInState();
      }
    },
    async changeProfileInfo(data: UserPatchPayload) {
      const { error, response } = await patchUser(this.profile.id, data);
      if (!error) {
        if (data.locale) {
          localStorage.setItem(LOCALE_STORAGE_KEY, data.locale);
        }

        this.profile = { ...this.profile, ...response.data };
      }
    },
  },
});
